"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var posthog_exports = {};
__export(posthog_exports, {
  PosthogAnalyticProvider: () => PosthogAnalyticProvider
});
module.exports = __toCommonJS(posthog_exports);
var import_posthog_js = __toESM(require("posthog-js"));
class PosthogAnalyticProvider {
  static {
    __name(this, "PosthogAnalyticProvider");
  }
  init(config) {
    if (config.POSTHOG_API_KEY !== void 0 && config.POSTHOG_API_KEY !== "" && config.POSTHOG_HOST !== null) {
      import_posthog_js.default.init(config.POSTHOG_API_KEY, {
        api_host: config.POSTHOG_HOST,
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: false
      });
      return true;
    }
    return false;
  }
  setUser(email) {
    if (!import_posthog_js.default._isIdentified()) {
      import_posthog_js.default.identify(email, { email });
    }
  }
  setAlias(distinctId, alias) {
    import_posthog_js.default.alias(alias, distinctId);
  }
  setTag(key, value) {
    import_posthog_js.default.setPersonProperties({ [key]: value });
  }
  setWorkspace(ws, guest) {
    const prop = guest ? "visited-workspace" : "workspace";
    this.setTag(prop, ws);
    if (!guest) import_posthog_js.default.group(prop, ws, { name: `${ws}` });
  }
  logout() {
    import_posthog_js.default.reset(true);
  }
  handleEvent(event, params) {
    import_posthog_js.default.capture(event, params);
  }
  handleError(error) {
    import_posthog_js.default.capture(error.message);
  }
  navigate(path) {
    import_posthog_js.default.capture("$pageview");
  }
}
//# sourceMappingURL=posthog.js.map
